"use client";

import { c as _c } from "react/compiler-runtime";
import * as Accordion from "@radix-ui/react-accordion";
import { motion } from "framer-motion";
import { FaqAccordionItem } from "./FaqAccordionItem";
import type { Question, Tab } from "./questions";
interface FaqAccordionListProps {
  questions: Question[];
  tab: Tab;
}
export function FaqAccordionList(t0) {
  const $ = _c(7);
  const {
    questions,
    tab
  } = t0;
  let t1;
  if ($[0] !== questions || $[1] !== tab) {
    let t2;
    if ($[3] !== tab) {
      t2 = (question, index) => <motion.div key={`${tab}-${question.id}`} initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.35,
        ease: "easeOut",
        delay: index * 0.05
      }}><FaqAccordionItem question={question} /></motion.div>;
      $[3] = tab;
      $[4] = t2;
    } else {
      t2 = $[4];
    }
    t1 = questions.map(t2);
    $[0] = questions;
    $[1] = tab;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[5] !== t1) {
    t2 = <section className="max-w-8xl w-full mx-auto px-6 sm:px-8 md:px-16 py-16"><Accordion.Root type="single" collapsible={true} className="w-full max-w-4xl mx-auto flex flex-col gap-3">{t1}</Accordion.Root></section>;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
}